import React from 'react';
import { EXPIRED, SKIPPED, NOT_SUBSCRIBED } from './boxStatusId';
import { activateMembership } from './boxButtonLinks';

const BoxTextBodyLinks = ({ boxStatusId, trackingUrl, body }) => (
  <>
    {(boxStatusId === NOT_SUBSCRIBED) && (
    <a href={activateMembership.href} className="highlighted">
      Activate Membership
    </a>
    )}
    {(boxStatusId === EXPIRED || boxStatusId === SKIPPED) && body && body.endsWith('?') && (
      <a href={process.env.REACT_APP_CUSTOMER_SERVICE_URL} className="highlighted">
        Contact Customer Service
      </a>
    )}
    {!!trackingUrl && (
      <a href={trackingUrl} className="challenge-highlighted">
        Track Your Order
      </a>
    )}
  </>
);

export default BoxTextBodyLinks;
